import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/stores/auth'
import LoginPage from '@/pages/LoginPage'
import DashboardPage from '@/pages/DashboardPage'
import TeacherDashboardPage from '@/pages/TeacherDashboardPage'
import PasswordResetPage from '@/pages/PasswordResetPage'
import SubscriptionPage from '@/pages/SubscriptionPage'
import SettingsPage from '@/pages/SettingsPage'
import ParentRegistrationPage from '@/pages/ParentRegistrationPage'
import ParentDashboardPage from '@/pages/ParentDashboardPage'
import ClassDetailPage from '@/pages/ClassDetailPage'
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage'
import ContactUsPage from '@/pages/ContactUsPage'
import ArchitectPage from '@/pages/ArchitectPage'

// Protected Route component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  
  if (!user) {
    return <Navigate to="/login" replace />
  }
  
  return <>{children}</>
}

// Role-based dashboard routing
function RoleBasedDashboard() {
  const { user } = useAuth()
  
  if (user?.role === 'PARENT') {
    return <div className="page-transition"><ParentDashboardPage /></div>
  }
  
  if (user?.role === 'ARCHITECT') {
    return <div className="page-transition"><ArchitectPage /></div>
  }

  if (user?.role === 'TEACHER') {
    return <div className="page-transition"><TeacherDashboardPage /></div>
  }
  
  return <div className="page-transition"><DashboardPage /></div>
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<div className="page-transition"><LoginPage /></div>} />
      <Route path="/reset-password" element={<div className="page-transition"><PasswordResetPage /></div>} />
      <Route path="/register" element={<div className="page-transition"><ParentRegistrationPage /></div>} />
      <Route path="/subscription" element={<div className="page-transition"><SubscriptionPage /></div>} />
      <Route path="/privacy" element={<div className="page-transition"><PrivacyPolicyPage /></div>} />
      <Route path="/contact" element={<div className="page-transition"><ContactUsPage /></div>} />
      <Route
        path="/parent"
        element={
          <ProtectedRoute>
            <div className="page-transition"><ParentDashboardPage /></div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/architect"
        element={
          <ProtectedRoute>
            <div className="page-transition"><ArchitectPage /></div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <RoleBasedDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/teacher-dashboard"
        element={
          <ProtectedRoute>
            <div className="page-transition"><TeacherDashboardPage /></div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <div className="page-transition"><SettingsPage /></div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/classes/:classId"
        element={
          <ProtectedRoute>
            <div className="page-transition"><ClassDetailPage /></div>
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default AppRoutes
